// 회원앱 가입 약관 원문. AOS strings.xml 의 allow_detail(이용약관)·allow_detail_second(개인정보처리 방침)와 같다.
// 앱 약관이 바뀌면 여기도 같이 바꾼다(2026-10-21).

export const APP_TERMS_OF_SERVICE = `이용약관

제1조 (목적)

본 이용약관은 바디스위치(BodySwitch, 이하 ”회사” 또는 ”플랫폼”)가 제공하는 운동 시설 예약, 정기권 및 일일권 판매, 출입 인증, 운동 관리 서비스(이하 ”서비스”)의 이용조건 및 운영에 관한 제반 사항을 규정함을 목적으로 합니다.

제2조 (용어의 정의)

본 약관에서 사용하는 주요 용어의 정의는 다음과 같습니다.

① ”회원” : 본 약관에 동의하고 개인정보를 제공하여 회원등록을 완료한 자
② ”이용계약” : 회사와 회원 간 체결되는 서비스 이용 계약
③ ”회원 아이디(ID)” : 회원 식별 계정 정보
④ ”비밀번호” : 계정 보호를 위한 인증 정보
⑤ ”센터” : 운동시설 제공 사업자
⑥ ”트레이너” : 운동 지도 제공자
⑦ ”정기권” : 일정 기간 반복 이용 가능한 구독형 상품
⑧ ”일일권” : 1회 또는 제한 횟수 이용 상품
⑨ ”예약” : 특정 시간 시설 이용 신청
⑩ ”출입 인증” : QR, 안면인식, IoT 등을 통한 출입 확인
⑪ ”노쇼” : 사전 취소 없이 미이용
⑫ ”해지” : 이용계약 종료

제3조 (약관 외 준칙)

① 회사는 환불정책, 노쇼정책 등 별도 운영정책을 둘 수 있습니다.
② 약관과 운영정책이 상충할 경우 운영정책이 우선합니다.
③ 관련 법령을 따릅니다.

제4조 (이용계약 체결)

① 회원가입 및 약관 동의 시 계약 성립
② 허위 정보 등록 시 이용 제한 가능

제5조 (서비스 이용 신청)

회원은 정확한 정보를 제공해야 하며, 허위 정보로 인한 책임은 회원에게 있습니다.

제6조 (개인정보 처리)

개인정보 처리에 관한 사항은 별도의 개인정보처리방침을 따릅니다.

제7조 (회사의 의무)

회사는 안정적인 서비스 제공 및 고객 응대를 위해 노력합니다.

제8조 (회원의 의무)

회원은 법령 및 약관을 준수해야 하며, 다음 행위를 금지합니다.
- 부정 이용
- 계정 공유
- 시설 훼손
- 서비스 방해

제9조 (서비스 이용 및 이용권)

① 회원은 정기권 및 일일권을 구매하여 서비스를 이용할 수 있습니다.

② 정기권 (구독형 이용권)
- 정기권은 일정 기간 동안 반복적으로 이용 가능한 구독형 상품입니다.
- 정기권은 회사가 정한 주기(월 단위 등)로 자동 갱신됩니다.

[자동결제 조건]
- 회원이 해지하지 않는 한 동일 조건으로 자동 결제됩니다.
- 결제일, 금액, 결제수단은 최초 결제 시 안내된 기준을 따릅니다.

[해지 정책]
- 회원은 언제든지 서비스 내에서 해지할 수 있습니다.
- 해지 시 다음 결제일부터 자동결제가 중단됩니다.

[이용 조건]
- 이용 가능 횟수 및 예약 조건은 회사 또는 센터 정책에 따릅니다.

③ 일일권
- 1회 또는 제한 횟수 이용
- 유효기간 경과 시 자동 소멸

④ 이용권 공통사항
- 타인 양도 및 판매 금지
- 부정 이용 시 회수 가능

제9-1조 (결제 및 자동결제)

① 서비스 이용을 위한 결제는 회사가 제공하는 결제수단을 통해 이루어집니다.
② 정기권은 자동결제 상품으로, 회원이 해지하지 않는 한 동일 조건으로 반복 결제됩니다.
③ 결제 실패 시 서비스 이용이 제한될 수 있습니다.
④ 결제 오류, 카드 한도 초과, 결제수단 변경 미등록 등으로 발생한 문제는 회원 책임입니다.
⑤ 회사는 결제대행사(PG)를 통해 결제를 처리할 수 있습니다.

제9-2조 (정기권 환불 및 중도해지)

① 환불은 관련 법령 및 회사 정책을 따릅니다.
② 환불 기준
- 이용 시작 전: 전액 환불
- 이용 시작 후: ”총 결제금액 – 사용 기간 또는 이용 횟수 차감 후 환불”
③ 다음 경우 환불이 제한될 수 있습니다.
- 이용이 상당 부분 진행된 경우
- 프로모션 및 할인 상품
④ 센터 정책에 따라 일부 기준이 달라질 수 있으며 사전 고지합니다.

제10조 (예약 및 이용 규정)

① 예약 시간 내 이용 가능
② 노쇼 및 반복 취소 시 이용 제한 가능
③ 센터 정책 따름
④ 정기권 이용자의 예약 횟수 및 이용 조건은 제한될 수 있음

제11조 (출입 인증 및 IoT 서비스)

① QR, 안면인식 등을 통한 출입
② 출입 기록은 분쟁 해결 자료로 활용
③ 타인 공유 금지

제12조 (서비스 이용 시간)

24시간 운영을 원칙으로 하나, 점검/장애 시 제한될 수 있음

제13조 (서비스 이용 해지)

회원은 언제든지 탈퇴 가능하며, 데이터는 법령에 따라 보관 후 삭제됩니다.

제14조 (서비스 이용 제한)

약관 위반, 부정 이용, 반복 노쇼 시 제한 가능

제15조 (게시물 관리)

불법 및 부적절 콘텐츠는 삭제될 수 있습니다.

제16조 (플랫폼 중개 서비스의 책임 제한)

① 회사는 운동시설 및 트레이닝 서비스를 직접 제공하지 않는 중개 플랫폼입니다.
② 시설 운영, 수업 진행, 안전관리, 트레이닝 내용에 대한 책임은 센터 또는 트레이너에게 있습니다.
③ 회원과 센터 간 발생한 분쟁은 당사자 간 해결을 원칙으로 합니다.
④ 회사는 다음 사항에 대해 책임을 지지 않습니다.
- 시설 이용 중 발생한 사고
- 트레이닝 결과에 대한 불만
- 센터 운영 중단
- 센터 환불 문제
- 예약 취소 분쟁

제17조 (서비스 변경 및 종료)

① 회사는 서비스 개선, 운영 정책 변경, 시스템 점검 등을 위해 서비스를 변경할 수 있습니다.
② 회사는 다음 경우 서비스 일부 또는 전체를 종료할 수 있습니다.
- 사업 종료
- 제휴 종료
- 시스템 변경
- 법적 문제 발생
③ 서비스 종료 시 사전 공지합니다.

제18조 (알림 및 통지)

앱 푸시, 문자, 알림톡, 이메일 등으로 안내합니다.

제19조 (손해배상)

① 회원의 약관 위반으로 회사에 손해가 발생한 경우 배상해야 합니다.
② 회사는 다음 경우 책임을 지지 않습니다.
- 천재지변
- 서버 장애
- 통신 장애
- 제3자 귀책
③ 회사의 책임은 법령이 허용하는 범위 내로 제한됩니다.

제20조 (준거법 및 관할)

① 본 약관은 대한민국 법률을 따릅니다.
② 분쟁 발생 시 회사 본점 소재지를 관할하는 법원을 관할 법원으로 합니다.

부칙

본 약관은 2026년 03월 01일부터 시행합니다.`;

export const APP_PRIVACY_POLICY = `개인정보처리 방침

제1조 (개인정보의 처리 목적)

바디스위치(이하 "회사")는 다음의 목적을 위하여 개인정보를 처리합니다.
처리 목적이 변경될 경우 「개인정보 보호법」 제18조에 따라 별도 동의를 받습니다.

1. 회원가입 및 관리
- 회원 식별 및 인증
- 회원자격 유지 및 관리
- 부정 이용 방지

2. 서비스 제공 (핵심)
- 운동시설 예약 및 이용
- 정기권(구독형 이용권) 및 일일권(1회/횟수권) 판매 및 관리
- 결제 및 정산 처리
- 출입 인증 (QR, 안면인식, IoT)
- 운동 데이터 기록 및 분석

3. 고객 상담 및 민원 처리
- 문의 대응 및 분쟁 처리


제2조 (개인정보의 처리 및 보유 기간)

① 회사는 법령 또는 이용자의 동의 범위 내에서 개인정보를 보유합니다.

1. 회원정보
- 회원 탈퇴 시까지
단, 아래의 경우 예외 적용
- 분쟁 발생 시: 해결 시까지
- 미정산 금액 존재 시: 정산 완료 시까지

2. 결제 및 이용권 정보 (정기권/일일권)
- 이용권 사용 완료 및 정산 완료 시까지
단, 관련 법령에 따라 보관
- 계약 및 결제 기록: 5년
- 소비자 분쟁 기록: 3년

3. 출입 및 로그 데이터
- 출입 인증 기록: 1년
- 접속 로그: 3개월


제3조 (이용자 권리)

이용자는 언제든지 다음 권리를 행사할 수 있습니다.
- 개인정보 열람
- 정정 및 삭제
- 처리 정지
요청 시 회사는 지체 없이 조치합니다.


제4조 (처리하는 개인정보 항목)

1. 회원가입
- 필수: 이름, 이메일, 전화번호, 비밀번호
- 선택: 성별, 생년월일

2. 서비스 이용 (정기권/일일권 포함)
- 필수
  · 이름, 연락처, 이메일
  · 예약 정보 (센터, 날짜, 시간)
  · 이용권 정보 (정기권 / 일일권 / 이용 내역)
  · 결제 정보 (카드, 계좌 등)
- 선택
  · 위치 정보
  · 운동 목적 및 신체 정보

3. 출입 인증 (IoT/안면인식)
- 출입 기록
- 기기 정보
- (선택 동의 시) 생체정보 (안면 인식 데이터)

4. 자동 수집 정보
- IP 주소
- 접속 로그
- 이용 기록


제5조 (개인정보의 제3자 제공)

회사는 서비스 제공을 위해 아래와 같이 개인정보를 제공합니다.

제공 대상: 제휴 센터, 트레이너
제공 항목: 이름, 연락처, 예약 정보, 이용권 정보 (정기권 / 일일권)
제공 목적: 예약 처리 및 서비스 제공, 이용자 관리 및 상담
보유 기간: 회원 탈퇴 시까지


제6조 (개인정보 처리 위탁)

회사는 원활한 서비스 제공을 위해 일부 업무를 외부에 위탁할 수 있습니다.
예시: 결제(PG사), 클라우드 서버, 문자 발송


제7조 (생체정보 처리)

① 회사는 안면인식 등 생체정보를 별도 동의 후에만 수집합니다.
② 이용 목적: 출입 인증
③ 보관 및 파기: 회원 탈퇴 또는 동의 철회 시 즉시 파기
④ 이용자는 언제든지 동의를 철회할 수 있습니다.


제8조 (개인정보의 파기)

① 목적 달성 시 즉시 파기
② 방법
- 전자 데이터: 복구 불가 방식 삭제
- 문서: 분쇄 또는 소각


제9조 (안전성 확보 조치)

회사는 다음과 같은 조치를 취합니다.
- 데이터 암호화
- 접근 권한 통제
- 보안 시스템 운영
- 내부 교육


제10조 (쿠키 및 자동 수집)

회사는 맞춤형 서비스를 위해 쿠키를 사용합니다.
이용자는 브라우저 설정을 통해 거부할 수 있습니다.


제11조 (개인정보 보호책임자)

- 성명: 한 상 엽
- 이메일: bodyswitch.kor@gmail.com


제12조 (권익 침해 구제)

이용자는 아래 기관에 문의할 수 있습니다.
- 개인정보 침해신고센터 (118)
- 개인정보 분쟁조정위원회


제13조 (개정)

본 방침은 2026년 03월 01일부터 적용됩니다.`;
